
import { debounce } from 'lodash';
export default {
  name: 'CustomField',
  props: {
    value: {
      required: true,
      type: String | Number | Boolean,
    },
    field: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: 'medium',
    },
    booleanBgColor: {
      type: String,
      default: 'background-color: none;',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      allowBubble: true,
    };
  },

  created() {
    this.debounceFunction = debounce((data) => {
      this.$emit('input', data);
      this.allowBubble = true;
    }, 1500);
  },

  beforeDestroy() {
    if (this.debounceFunction) {
      this.debounceFunction.cancel();
    }
  },

  computed: {
    getDate: {
      get() {
        return this.$nuxt.$helpers.formatDate(this.value);
      },
      set(value) {
        if (value === '' || value === null || value === undefined) {
          this.debounceFunction.cancel();
          this.allowBubble = true;
          this.$emit('input', null);
          return;
        }
        if (this.isValidDate(value)) {
          this.bubbleUp(value);
        }
      },
    },
    bool: {
      get() {
        return this.value;
      },
      set(value) {
        this.bubbleUp(value);
      },
    },
  },

  methods: {
    isValidDate(d) {
      return new Date(d).toString() !== 'Invalid Date';
    },

    keyup(data) {
      this.allowBubble = false;
      this.debounceFunction(data);
    },
    bubbleUp(data) {
      if (this.allowBubble) {
        this.$emit('input', data);
      }
    },
  },
};
